import { types, actions } from './requests'
export const DELETECORP_TYPES = {
    ...types('DELETECORP'),
}
export const DELETECORP_ACTIONS = {
    ...actions('DELETECORP'),
}
